import { render, staticRenderFns } from "./UiEmail.vue?vue&type=template&id=26747039"
import script from "./UiEmail.vue?vue&type=script&lang=js"
export * from "./UiEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports